export default "__VITE_ASSET__B38CZfw5__"